import React from 'react';

import MFormContainerView from './MFormContainer.view';

type Props = {
  className?: string;
  headerClassName?: string;
  title?: string;
  headerActions?: JSX.Element | JSX.Element[] | null;
  headerJSX?: JSX.Element | JSX.Element[] | null;
  isFullScreen?: boolean;
  onBack?: () => void;
  onFullScreen?: () => void;
};

const MFormContainer: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MFormContainerView
      className={props.className}
      headerClassName={props.headerClassName}
      title={props.title}
      headerActions={props.headerActions}
      headerJSX={props.headerJSX}
      isFullScreen={props.isFullScreen}
      onBack={props.onBack}
      onFullScreen={props.onFullScreen}
    >
      {props.children}
    </MFormContainerView>
  );
};

MFormContainer.displayName = 'MFormContainer';
MFormContainer.defaultProps = {};

export default MFormContainer;
